import { TFilterSelected } from '../filter.types';
import { TPaginationInfo } from '../input-app/fabric-inspection/api.types';
import { TM8MachineId } from './factory.types';

export type TAttachmentSerialNumber = string;

export type TAttachmentDetails = {
  attachmentType: string;
  serialNumber: TAttachmentSerialNumber;
  machineType: string;
  machineCategory: string;
  machineSubCategory?: string;
  machineBrand: string;
  status: 'AVAILABLE' | 'ACTIVE' | 'IN_REPAIR' | 'REPAIR_REJECTED';
  lastUpdatedOn: number;
};
export type TREQUEST_ATTACHMENT_LIST = {
  selectedFilters: TFilterSelected[];
  page: number;
  itemsPerPage: number;
  searchStrOpt?: string;
};
export type TRESPONSE_ATTACHMENT_LIST = {
  attachmentDetailList: TAttachmentDetails[];
  filters: TFilterSelected[];
  paginationInfo: TPaginationInfo;
};
export type TREQUEST_ATTACHMENT_DELETE = { attachmentSerialNumbers: TAttachmentSerialNumber[] };
export type TREQUEST_ATTACHMENT_PRINT_QR = TREQUEST_ATTACHMENT_DELETE;

export type TREQUEST_ATTACHMENT_UPDATE = {
  attachmentSerialNumber: TAttachmentSerialNumber;
  machineType: string;
  machineCategory: string;
  machineSubCategory?: string;
  brand: string;
};

export const ATTACHMENT_APPROVAL_STATUS = ['IN_REPAIR', 'REPAIR_APPROVED', 'REPAIR_REJECTED'] as const;
export type TREQUEST_ATTACHMENT_APPROVAL_LIST = {
  status: (typeof ATTACHMENT_APPROVAL_STATUS)[number];
  selectedFilters: TFilterSelected[];
  page: number;
  itemsPerPage: number;
  searchStrOpt?: string;
};
export type TRESPONSE_ATTACHMENT_APPROVAL_LIST = {
  attachmentRepairDetailList: {
    actionTakenAt: number;
    machineLocation?: string;
    machineSerialNumber: string;
    actionTakenBy: string;
    attachmentSerialNumber: TAttachmentSerialNumber;
  }[];
  filters: TFilterSelected[];
  paginationInfo: TPaginationInfo;
};

export type TREQUEST_ATTACHMENT_ACTION = { attachmentSerialNumber: TAttachmentSerialNumber } & (
  | { actionType: 'REMOVED_FROM_MACHINE' | 'SENT_TO_REPAIR' }
  | { actionType: 'ASSIGNED_TO_MACHINE'; machineSerialNumber: string; machineId: TM8MachineId }
);

export type TREQUEST_ATTACHMENT_APPROVAL_ACTION = {
  actionType: 'REPAIR_APPROVED' | 'REPAIR_REJECTED' | 'SENT_TO_REPAIR';
  attachmentSerialNumbers: TAttachmentSerialNumber[];
};

export type TRESPONSE_GET_ATTACHMENT_DETAILS_BY_SERIAL_NUM = Pick<
  TAttachmentDetails,
  'attachmentType' | 'serialNumber' | 'machineType' | 'machineCategory' | 'machineSubCategory' | 'machineBrand'
>;
